export const PurchaseOrderRoutes = {
  path: 'purchase-orders',
  async lazy() {
    const { Parent } = await import('pages/purchase-orders');
    return { Component: Parent };
  },
  handle: { name: 'Supplier management', category: 'Supplier management' },
  children: [
    {
      path: '',
      async lazy() {
        const { Index } = await import('pages/purchase-orders');
        return { Component: Index };
      },

      children: [
        {
          path: 'add',
          async lazy() {
            const { AddPurchaseOrder } = await import('pages/purchase-orders');
            return { Component: AddPurchaseOrder };
          },
          handle: { name: 'Add new purchase order', category: 'Supplier management' },
        },
      ],
    },
    {
      path: ':purchaseOrderId',
      children: [
        {
          path: 'inspect',
          async lazy() {
            const { InspectPurchaseOrder } = await import('pages/purchase-orders');
            return { Component: InspectPurchaseOrder };
          },
          handle: { name: 'Inspect purchase order', category: 'Supplier management' },
        },
      ],
    },
  ],
};
